"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestEventsRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for stream management
 * Handles live stream data and monitoring
 */
class TestEventsRoutes extends base_1.ApiBase {
    /**
     * Trigger a test event for development/testing purposes
     */
    async triggerTestEvent(payload) {
        return await this.api.post(`${constants_1.ROUTES.TEST_EVENTS}/trigger`, payload);
    }
}
exports.TestEventsRoutes = TestEventsRoutes;
//# sourceMappingURL=test-events.js.map